import { Injectable } from '@angular/core';
import { RequestOptions, Response } from '@angular/http';

import { AuthHttp } from '../../../../../common/index';
import { AppSettings } from '../../../../../settings/index';

@Injectable()
export class PreferredDeliveryTimeSlotService {
  constructor(private http: AuthHttp) { }

  getPreferredDeliveryTimeSlots(mode: string) {
    return this.http.get(AppSettings.apiEndpoint + "PreferredDeliveryTimeSlot/GetPreferredDeliveryTimeSlots?mode=" + mode)
      .map((response: Response) => response.json());
  }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/preferred-delivery-time-slot.service.ts